import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "aiSpeachCreatorContainer"
};
const _hoisted_2 = {
  key: 0,
  class: "demoLimitReached"
};
const _hoisted_3 = {
  class: "demoLimitIconWrap"
};
const _hoisted_4 = {
  class: "demoLimitTitle"
};
const _hoisted_5 = {
  class: "demoLimitSubtitle"
};
const _hoisted_6 = {
  class: "demoLimitSupport"
};
const _hoisted_7 = {
  key: 1,
  class: "aiWizardWrapper"
};
const _hoisted_8 = {
  key: 0,
  class: "titleText"
};
const _hoisted_9 = {
  key: 1,
  class: "subtitleText"
};
const _hoisted_10 = {
  key: 2,
  class: "uploadParamsLayout"
};
const _hoisted_11 = {
  class: "uploadStep"
};
const _hoisted_12 = {
  class: "uploadDropInner"
};
const _hoisted_13 = {
  class: "uploadIconWrap"
};
const _hoisted_14 = {
  class: "uploadImportPlaceholder"
};
const _hoisted_15 = {
  class: "uploadSupportedFormats"
};
const _hoisted_16 = {
  class: "uploadImportPlaceholderFile"
};
const _hoisted_17 = {
  class: "fileName"
};
const _hoisted_18 = {
  class: "fileProgress"
};
const _hoisted_19 = {
  class: "iconCheck"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  key: 0,
  class: "languageSection"
};
const _hoisted_22 = {
  class: "languageLabel"
};
const _hoisted_23 = {
  key: 3,
  class: "buttonBottomLine"
};
const _hoisted_24 = {
  key: 4,
  class: "modePickerStep"
};
const _hoisted_25 = {
  key: 5,
  class: "roleSelectorStep"
};
const _hoisted_26 = {
  key: 6,
  class: "scenarioSelectorStep"
};
const _hoisted_27 = {
  key: 7,
  class: "styleStepContainer"
};
const _hoisted_28 = {
  key: 8,
  class: "stepsGeneratorStep"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_el_step = _resolveComponent("el-step");
  const _component_el_steps = _resolveComponent("el-steps");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_progress = _resolveComponent("el-progress");
  const _component_loader = _resolveComponent("loader");
  const _component_w_select = _resolveComponent("w-select");
  const _component_AIModePicker = _resolveComponent("AIModePicker");
  const _component_AIRoleSelector = _resolveComponent("AIRoleSelector");
  const _component_AIScenarioSelector = _resolveComponent("AIScenarioSelector");
  const _component_AIStyleStep = _resolveComponent("AIStyleStep");
  const _component_AIStepsGenerator = _resolveComponent("AIStepsGenerator");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.isLimitReached ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_icon, {
    icon: "alert-circle-outline",
    size: "huge",
    color: "primary"
  })]), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('aiSpeachGenerator.limitReached.title')), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('aiSpeachGenerator.limitReached.subtitle', {
    count: _ctx.speachLimit
  })), 1), _createElementVNode("div", _hoisted_6, [_createVNode(_component_standard_button, {
    onAction: _ctx.contactSupport
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('aiSpeachGenerator.limitReached.support')), 1)]),
    _: 1
  }, 8, ["onAction"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_steps, {
    class: "aiWizardStepper",
    active: _ctx.currentStepperIndex,
    "align-center": ""
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stepperItems, item => {
      return _openBlock(), _createBlock(_component_el_step, {
        key: item.key,
        title: item.label
      }, null, 8, ["title"]);
    }), 128))]),
    _: 1
  }, 8, ["active"]), _ctx.step === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('aiSpeachGenerator.title')), 1)) : _createCommentVNode("", true), _ctx.step === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('aiSpeachGenerator.subtitle')), 1)) : _createCommentVNode("", true), _ctx.step === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_upload, {
    class: "uploadElementAI",
    drag: "",
    disabled: _ctx.uploadInProgress,
    multiple: "",
    "show-file-list": false,
    "file-list": _ctx.listOfUserFile,
    "onUpdate:fileList": _cache[0] || (_cache[0] = $event => _ctx.listOfUserFile = $event),
    "auto-upload": false,
    accept: _ctx.acceptedFileTypes,
    onChange: _ctx.onFileChange
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_icon, {
      icon: "cloud-upload-outline",
      size: "huge",
      color: "dark"
    })]), _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('aiSpeachGenerator.upload.placeholder')), 1), _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('aiSpeachGenerator.upload.supportedFormats')), 1), _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('aiSpeachGenerator.upload.file')), 1)])]),
    _: 1
  }, 8, ["disabled", "file-list", "accept", "onChange"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.proceededFile, file => {
    return _openBlock(), _createElementBlock("div", {
      class: "fileElement",
      key: file.uid
    }, [_createElementVNode("div", _hoisted_17, _toDisplayString(file.name), 1), _createElementVNode("div", _hoisted_18, [_createVNode(_component_el_progress, {
      percentage: file.progress > 0 ? file.progress : 10,
      "show-text": false,
      indeterminate: file.progress === 0,
      duration: 1
    }, null, 8, ["percentage", "indeterminate"])]), _createElementVNode("div", _hoisted_19, [file.data ? (_openBlock(), _createBlock(_component_icon, {
      key: 0,
      icon: "check-circle",
      color: "success",
      size: "default"
    })) : _createCommentVNode("", true), file.progress == -1 ? (_openBlock(), _createBlock(_component_icon, {
      key: 1,
      icon: "close-octagon-outline",
      color: "danger",
      size: "default"
    })) : _createCommentVNode("", true), !file.data && file.progress >= 0 ? (_openBlock(), _createBlock(_component_loader, {
      key: 2,
      "spinner-size": "spinnersSmall"
    })) : _createCommentVNode("", true)]), _createElementVNode("div", {
      class: "iconRemove",
      onClick: $event => _ctx.removeFile(file)
    }, [_createVNode(_component_icon, {
      icon: "delete-outline",
      size: "default",
      color: "light2"
    })], 8, _hoisted_20)]);
  }), 128)), _ctx.proceededFile.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('aiSpeachGenerator.options.language')), 1), _createVNode(_component_w_select, {
    placeholder: _ctx.$t('aiSpeachGenerator.options.languages.placeholder'),
    options: _ctx.listOfLanguageOptions,
    value: _ctx.languageSelected,
    onChange: _ctx.onLanguageChange
  }, null, 8, ["placeholder", "options", "value", "onChange"])])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _ctx.step === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_component_standard_button, {
    class: "uploadDocumentButton",
    disabled: !_ctx.isAllFileProceed,
    onAction: _ctx.validateUploadDocument
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('aiSpeachGenerator.generateButton')) + " ", 1), _createVNode(_component_icon, {
      icon: "arrow-right"
    })]),
    _: 1
  }, 8, ["disabled", "onAction"])])) : _createCommentVNode("", true), _ctx.step === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createVNode(_component_AIModePicker, {
    "ai-files": _ctx.proceededFile,
    onModeSelected: _ctx.onModeSelected,
    onBack: _ctx.onModePickerBack
  }, null, 8, ["ai-files", "onModeSelected", "onBack"])])) : _createCommentVNode("", true), _ctx.step === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createVNode(_component_AIRoleSelector, {
    "ai-files": _ctx.proceededFile,
    language: _ctx.languageSelected,
    onRolesSelected: _ctx.onRolesSelected,
    onBack: _ctx.onRoleSelectorBack
  }, null, 8, ["ai-files", "language", "onRolesSelected", "onBack"])])) : _createCommentVNode("", true), _ctx.step === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createVNode(_component_AIScenarioSelector, {
    "ai-files": _ctx.proceededFile,
    language: _ctx.languageSelected,
    roles: _ctx.selectedRoles,
    onScenarioSelected: _ctx.onScenarioSelected,
    onBack: _ctx.onScenarioSelectorBack
  }, null, 8, ["ai-files", "language", "roles", "onScenarioSelected", "onBack"])])) : _createCommentVNode("", true), _ctx.step === 4 ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(_component_AIStyleStep, {
    "advanced-tts-enabled": _ctx.advancedTts === 'true',
    "avatar-custom": _ctx.avatarCustom,
    "content-mode": _ctx.contentMode,
    "generation-mode": _ctx.generationmode,
    duration: _ctx.durationSelected,
    "allow-reorder": _ctx.allowReorder,
    "specific-prompt": _ctx.specificPrompt,
    onContentMode: _ctx.onContentModeChange,
    onGenerationMode: _ctx.onGenerationModeChange,
    onDurationChange: _ctx.onDurationChange,
    onAllowReorder: _ctx.onAllowReorder,
    onSpecificPrompt: _ctx.onSpecificPromptChange,
    onValidate: _ctx.onStyleValidated,
    onBack: _ctx.onStyleBack
  }, null, 8, ["advanced-tts-enabled", "avatar-custom", "content-mode", "generation-mode", "duration", "allow-reorder", "specific-prompt", "onContentMode", "onGenerationMode", "onDurationChange", "onAllowReorder", "onSpecificPrompt", "onValidate", "onBack"])])) : _createCommentVNode("", true), _ctx.step === 6 ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createVNode(_component_AIStepsGenerator, {
    "ai-files": _ctx.proceededFile,
    "uploaded-files": _ctx.listOfUserFile,
    language: _ctx.languageSelected,
    duration: _ctx.durationSelected,
    specificPrompt: _ctx.specificPrompt,
    allowReorder: _ctx.allowReorder,
    "weet-endpoint": _ctx.weetEndpoint,
    "generation-mode": _ctx.generationmode,
    "style-avatar": _ctx.styleAvatar,
    "style-use-avatar": _ctx.styleUseAvatar,
    "style-background": _ctx.styleBackground,
    "style-voice": _ctx.styleVoice,
    "style-image-style": _ctx.styleImageStyle,
    "style-visual-template": _ctx.styleVisualTemplate,
    "style-explainer-enabled": _ctx.styleExplainerEnabled,
    "style-quiz-enabled": _ctx.styleQuizEnabled,
    "style-annotations-enabled": _ctx.styleAnnotationsEnabled,
    "style-full-explainer": _ctx.styleFullExplainer,
    "link-id": _ctx.linkId,
    "full-content-generation": _ctx.fullContentGeneration === 'true',
    "demo-mode": _ctx.demoMode === 'true',
    onGenerationPhase: _ctx.onGenerationPhase,
    onBack: _ctx.onStepsGeneratorBack
  }, null, 8, ["ai-files", "uploaded-files", "language", "duration", "specificPrompt", "allowReorder", "weet-endpoint", "generation-mode", "style-avatar", "style-use-avatar", "style-background", "style-voice", "style-image-style", "style-visual-template", "style-explainer-enabled", "style-quiz-enabled", "style-annotations-enabled", "style-full-explainer", "link-id", "full-content-generation", "demo-mode", "onGenerationPhase", "onBack"])])) : _createCommentVNode("", true)]))]);
}